import SignUpView from './SignUpView'
export default SignUpView
